import * as React from "react";
import { useMemo } from "react";
import { Badge, Col, Row } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import { formatReadableNumber } from "util/NumberFormatting";
import ModelProviderRequiredAlert from "aiagent/components/ModelProviderRequiredAlert";
import { DEFAULT_LAYOUT } from "./AgentWorkflowRuns/Constants";
import fetchAgentWorkflowRuns from "./AgentWorkflowRuns/fetchAgentWorkflowRuns";
import fetchWorkflowRunSlices from "./AgentWorkflowRuns/fetchWorkflowRunSlices";
import customColumnRenderers from "./AgentWorkflowRuns/ColumnRenderers";
import expandedSections from "./AgentWorkflowRuns/expandedSections";
import AgentWorkflowPageNavigation from "./AgentWorkflowPageNavigation";
const KEY_PREFIX = ["aiagent", "workflow-runs"];
const keyFn = (searchParams) => [...KEY_PREFIX, searchParams];
const AgentWorkflowRunsPage = () => {
  const sliceRenderers = useMemo(
    () => ({
      type: {
        renderAdditional: (slice) => {
          var _a, _b;
          const headsUp = (_b = (_a = slice.meta) == null ? void 0 : _a.headsUpCount) != null ? _b : 0;
          return /* @__PURE__ */ React.createElement(React.Fragment, null, headsUp > 0 && /* @__PURE__ */ React.createElement(Badge, { bsStyle: "warning" }, formatReadableNumber(headsUp)), /* @__PURE__ */ React.createElement(Badge, null, formatReadableNumber(slice.count)));
        }
      }
    }),
    []
  );
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Agent workflow runs" }, /* @__PURE__ */ React.createElement(AgentWorkflowPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: "Agent Workflow Runs" }, /* @__PURE__ */ React.createElement("span", null, "Review AI agent workflow execution history, including outcome summaries and basic run metadata. Scheduled workflows are checked every minute and run when their interval is due. Click a run to view its report.")), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ModelProviderRequiredAlert, null), /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "agent workflow runs",
      tableLayout: DEFAULT_LAYOUT,
      fetchEntities: fetchAgentWorkflowRuns,
      fetchSlices: fetchWorkflowRunSlices,
      sliceRenderers,
      fetchOptions: { refetchInterval: 5e3 },
      keyFn,
      columnRenderers: customColumnRenderers,
      expandedSectionRenderers: expandedSections,
      entityAttributesAreCamelCase: false
    }
  ))));
};
export default AgentWorkflowRunsPage;
